var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogSheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32623 8.03052H3.9395V24.9998H3.32623V8.03052Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85992 9.48926H5.47319V25.0001H4.85992V9.48926Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39312 11.3047H7.00638V25H6.39312V11.3047Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92632 12.5669H8.53958V24.9962H7.92632V12.5669Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45953 13.7961H10.0728V24.9961H9.45953V13.7961Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9932 12.5669H11.6065V24.9962H10.9932V12.5669Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5264 11.1323H13.1397V24.996H12.5264V11.1323Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0596 10.1201H14.6729V24.9958H14.0596V10.1201Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5933 9.71094H16.2066V24.9964H15.5933V9.71094Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.126 11.1323H17.7393V24.996H17.126V11.1323Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6597 12.5669H19.273V24.9962H18.6597V12.5669Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1924 14.2061H20.8058V24.9962H20.1924V14.2061Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7261 15.6484H22.3394V24.9956H21.7261V15.6484Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2598 16.9805H23.8731V25.0001H23.2598V16.9805Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7925 19.3982H25.4058V25H24.7925V19.3982Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25566 6.48514L9.38898 12.8779H9.41657C9.45572 12.9145 9.49786 12.9448 9.54236 12.9683L9.59134 12.9928C9.64696 13.016 9.70493 13.0283 9.76311 13.0297C9.81488 13.0289 9.86643 13.0191 9.91649 13.0011L9.96248 12.9805C10.0008 12.9623 10.0378 12.9388 10.0729 12.9108H10.1005L15.5805 8.02183L24.7618 16.6891L24.0442 18.2833L28.0001 18.3733L26.0836 13.7548L25.3967 15.2833L15.97 6.38699C15.7382 6.1989 15.4474 6.1989 15.2156 6.38699L9.80616 11.243L4.01018 5.1944C3.88269 5.05033 3.7169 4.98144 3.55091 5.00431C3.38469 5.02718 3.23282 5.13952 3.13014 5.31531C3.02725 5.49111 2.98254 5.71522 3.00629 5.93619C3.03003 6.15687 3.12009 6.35525 3.25571 6.48531L3.25566 6.48514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogSheet);
export default __webpack_public_path__ + "static/media/LogSheet.4b6111a85d509f3b66ede8fad1c56c75.svg";
export { ForwardRef as ReactComponent };